// semeia-disable-reexport
import type HealthCentre from "parog-web/models/health-centre";
import type Medic from "parog-web/models/medic";

export interface MedicsByHealthCentre {
  healthCentreName: string;
  healthCentre?: HealthCentre;
  medics: Medic[];
}

const NO_HEALTH_CENTRE_KEY = "no-health-centre";
const NO_HEALTH_CENTRE_NAME = "Aucun centre de rattachement";

export function getMedicsByHealthCentre(
  medics: Medic[]
): MedicsByHealthCentre[] {
  const medicsByHealthCentreMap: Record<string, MedicsByHealthCentre> = {};

  medics.forEach(medic => {
    const injectMedic = injectMedicFunc(medicsByHealthCentreMap, medic);

    if (medic.healthCentres?.length > 0) {
      medic.healthCentres.forEach(healthCentre => {
        injectMedic(healthCentre.id, healthCentre);
      });
    } else {
      injectMedic(NO_HEALTH_CENTRE_KEY, NO_HEALTH_CENTRE_NAME);
    }
  });

  return Object.values(medicsByHealthCentreMap);
}

export function sortedMedicsByHealthCentre(
  medics: Medic[],
  currentMedic: Medic | undefined
): MedicsByHealthCentre[] {
  const medicsByHealthCentre = getMedicsByHealthCentre(medics);

  medicsByHealthCentre.forEach(medicByHc => {
    medicByHc.medics = medicByHc.medics.toSorted((m1, m2) => {
      const rolesComparison = m1.role.localeCompare(m2.role);
      const lastNameComparison = m1.lastName.localeCompare(m2.lastName);
      return rolesComparison == 0 ? lastNameComparison : rolesComparison;
    });
  });

  return medicsByHealthCentre.filter(obj => {
    if (obj.healthCentre && currentMedic) {
      return currentMedic.healthCentres.includes(obj.healthCentre);
    }
    return true;
  });
}

function injectMedicFunc(
  medicsByHealthCentreMap: Record<string, MedicsByHealthCentre>,
  medic: Medic
): (healthCentreId: string, healthCentreOrName: HealthCentre | string) => void {
  return function injectMedic(
    healthCentreId: string,
    healthCentreOrName: HealthCentre | string
  ) {
    const healthCentre =
      typeof healthCentreOrName == "string" ? undefined : healthCentreOrName;
    const healthCentreName =
      typeof healthCentreOrName == "string"
        ? healthCentreOrName
        : healthCentreOrName.name;

    if (!medicsByHealthCentreMap[healthCentreId]) {
      medicsByHealthCentreMap[healthCentreId] = {
        healthCentre,
        healthCentreName,
        medics: [medic]
      };
    } else {
      medicsByHealthCentreMap[healthCentreId].medics.push(medic);
    }
  };
}
